import React from 'react';
import { useLocalizationContext } from '@im/react-localization';
import { useSocialMedias } from './useSocialMedias';
import { useIsResolution } from '@im/ui-lib/responsive';

type Props = {
  height?: string;
  width?: string;
};

export const IngramAppLinks = (props: Readonly<Props>) => {
  const { height = 'auto', width = 'auto' } = props;
  const { locale } = useLocalizationContext();
  const socialMedias = useSocialMedias(locale);
  const isMobile = useIsResolution({ max: 768 });
  const buildTrackingUrl = (url: string) => {
    if (!url) return '';
    const appStore = url.includes('ios.html') ? 'ios' : 'android';
    return `${url}&UTM_Campaign=x4c_login_page_${appStore}`;
  };

  const appStoreLinks = socialMedias?.appStore?.map((appStore) => ({
    ...appStore,
    url: buildTrackingUrl(appStore.url),
  }));

  return (
    <>
      {appStoreLinks?.map((appStore) => (
        <a
          data-name={`${appStore.name}-X4CWeb_LoginPage`}
          href={appStore.url}
          key={appStore.name}
          rel="noreferrer"
          style={{ height, width }}
          target={isMobile ? '_self' : '_blank'}
        >
          <img
            alt={appStore.name}
            src={appStore.iconImage}
            style={{ display: 'block', height, width }}
          />
        </a>
      ))}
    </>
  );
};
